export default __webpack_public_path__ + "static/media/avatar-3.7ddfac87.jpg";